import { render, staticRenderFns } from "./SuperviellePay.vue?vue&type=template&id=4274959e&scoped=true"
import script from "./SuperviellePay.vue?vue&type=script&lang=js"
export * from "./SuperviellePay.vue?vue&type=script&lang=js"
import style0 from "./SuperviellePay.vue?vue&type=style&index=0&id=4274959e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4274959e",
  null
  
)

export default component.exports